"use strict";

var _defineProperty2 = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResource = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _make = require("./make");

var _react = require("react");

var _Loader = require("../Loader");

var _hooks = require("../hooks");

var _rxjs = require("rxjs");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useResource = function useResource(options, complete, unmount) {
  var resource = (0, _react.useMemo)(function () {
    return {};
  }, []);
  var loader = (0, _Loader.useLoader)();
  var completed = (0, _hooks.useCloseableAsync)(function (closeRef) {
    // tasks of making and loading resources
    var tasks = Object.entries(options).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          option = _ref2[1];

      return option instanceof Function ? // make resource
      Promise.resolve(option(_make.makeResource)) // make resource
      .then(function (save) {
        return closeRef.current || save(name, loader);
      }) // save resource
      .then(function () {
        closeRef.current || loader.emit('load', loader, loader.resources[name]);
      }) // emit load succeed event
      .catch(function (error) {
        if (loader.resources[name] == null) {
          // make failed resource
          var _resource = new _make.Resource(name, "#".concat(name));

          _resource.error = error;
          loader.resources[name] = _resource;
        }

        closeRef.current || loader.emit('error', error, loader, loader.resources[name]); // emit load failed event

        throw error;
      }).finally(function () {
        return loader.emit('progress', loader, loader.resources[name]);
      }) //emit load finish event
      : // load resource
      Promise.resolve(option).then(function (_ref3) {
        var url = _ref3.url,
            options = _ref3.options,
            callback = _ref3.callback;
        closeRef.current || loader.add(name, url, options, callback);
      });
    }); // load finished callback

    var onLoad = function onLoad(resolve) {
      return function () {
        Object.defineProperties(resource, Object.keys(options).map(function (name) {
          return _defineProperty2({}, name, {
            configurable: true,
            enumerable: true,
            get: function get() {
              return loader.resources[name];
            }
          });
        }).reduce(function (dict, props) {
          return _objectSpread({}, dict, {}, props);
        }, {}));
        return (0, _rxjs.timer)(0).toPromise() // the `width` and `height` has not set after first loaded, delay it to the next event loop.
        .then(function () {
          return complete && complete(resource);
        }).then(function () {
          return resolve(true);
        });
      };
    }; // waits all tasks finished


    return Promise.all(tasks).then(function () {
      return closeRef.current || new Promise(function (resolve) {
        return loader.load(onLoad(resolve));
      });
    });
  }, function (_completed) {
    unmount && unmount();
    loader.reset();
    PIXI.utils.clearTextureCache();
  });
  (0, _react.useDebugValue)(completed, function (completed) {
    return completed ? 'finished' : 'loading';
  });
  return completed ? resource : null;
};

exports.useResource = useResource;

useResource.query = function (resource) {
  return (0, _react.useMemo)(function () {
    if (resource == null) return function (_field) {
      return {};
    };
    return function (field) {
      return Object.entries(resource).reduce(function (dict, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            name = _ref6[0],
            value = _ref6[1];

        return _objectSpread({}, dict, _defineProperty2({}, name, value[field]));
      }, {});
    };
  }, [resource]);
};